import React, { useEffect, useState } from "react";
import { CRMLayout } from "@/components/CRMLayout";
import { api } from "@/lib/api";
import { Bell, CheckCircle2 } from "lucide-react";

const Notifications = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/crm/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  const markRead = async (id) => { await api.post(`/crm/notifications/${id}/read`); load(); };
  return (
    <CRMLayout>
      <div className="mb-6" data-testid="crm-notifications-page">
        <div className="overline text-gold">Inbox</div>
        <h1 className="font-display text-3xl text-navy mt-2">Notifications</h1>
      </div>
      <div className="bg-white border border-slate-200 divide-y divide-slate-100">
        {items.map((n) => (
          <div key={n.id} className={`p-5 flex items-start gap-4 ${!n.read ? "bg-slate-50" : ""}`} data-testid={`notif-${n.id}`}>
            <Bell className={`w-5 h-5 mt-0.5 ${!n.read ? "text-gold" : "text-slate-300"}`} strokeWidth={1.5} />
            <div className="flex-1">
              <div className="font-semibold text-navy">{n.title}</div>
              <div className="text-sm text-slate-600 mt-1">{n.body}</div>
              <div className="text-xs text-slate-400 mt-2">{new Date(n.created_at).toLocaleString()}</div>
            </div>
            {!n.read && <button onClick={() => markRead(n.id)} className="inline-flex items-center gap-1.5 text-xs text-navy hover:text-gold" data-testid={`notif-read-${n.id}`}><CheckCircle2 className="w-4 h-4" /> Mark read</button>}
          </div>
        ))}
        {items.length === 0 && <div className="p-10 text-center text-slate-500">No notifications yet.</div>}
      </div>
    </CRMLayout>
  );
};

export default Notifications;
